import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import ArticleCardSkeleton from '@/app/components/listing/skeleton-loaders/ArticleCardSkeleton.vue'

const numberOfCardsToRender = 3

export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlesBlockSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingBlockLayout, { title: "Articles" }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(numberOfCardsToRender, (i) => {
        return _createVNode(ArticleCardSkeleton, { key: i })
      }), 64))
    ]),
    _: 1
  }))
}
}

})